"use client";

import Script from "next/script";

declare global {
	interface Window {
		Plain?: {
			init: (config: {
				appId: string;
				style?: {
					brandColor?: string;
					brandBackgroundColor?: string;
					launcherBackgroundColor?: string;
					launcherIconColor?: string;
				};
			}) => void;
		};
		onPlainLoad?: () => void;
	}
}

const ChatWidget = () => {
	return (
		<>
			<Script
				src="https://chat.cdn-plain.com/index.js"
				strategy="afterInteractive"
				onLoad={() => {
					if (window.Plain) {
						window.Plain.init({
							appId: "liveChatApp_01JQZMB8A8N7F1CNVTCXHDFWX1",
							style: {
								brandColor: "hsl(165 68% 40%)",
								brandBackgroundColor: "hsl(165 68% 40%)",
								launcherBackgroundColor: "hsl(165 68% 40%)",
								launcherIconColor: "hsl(0, 0%, 100%)",
							},
						});
					}
				}}
			/>
		</>
	);
};

export default ChatWidget;
